export default __webpack_public_path__ + "img/about_us_ps_1-c8eab6496b9f235bbcadd5dee0ab3f3d.png";